import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60ef326c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "16",
    cy: "16",
    r: "15",
    stroke: "#00AC54",
    "stroke-width": "2"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.9091 16H21.0909",
    stroke: "#00AC54",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16 10.9092L21.0909 16.0001L16 21.091",
    stroke: "#00AC54",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]




export default {
  __name: 'NextDaysButton',
  props: {
    isDisabled: {
        type: Boolean,
        default: false,
    },
},
  emits: ['onNextDaysClick'],
  setup(__props, { emit }) {

const props = __props;



const handleClick = () => {
    emit('onNextDaysClick');
};



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("button", {
    disabled: __props.isDisabled,
    class: "Button Button--no-style",
    type: "button",
    onClick: handleClick
  }, _hoisted_3, 8, _hoisted_1))
}
}

}